<template>
  <div>
    <v-switch v-model="isCreation"
              :label="isCreation ? 'Création' : 'Sélection'"
              color="valid"
    />
    <template v-if="!isCreation">
      <v-radio-group v-model="control.value"
                     @change="onEditControl('value', $event)"
      >
        <v-text-field
          v-model="search"
          append-icon="search"
          :label="$t('components.questions.list.header.search')"
          single-line
          hide-details
          color="valid"
        />
        <question-edit-panel-table :loading-question-terminate="loadingQuestionLikert"
                                   :questions-props="availableLikerts"
                                   :search="search"
        />
      </v-radio-group>
    </template>
    <template v-else>
      <form-likert :is-clone="false"
                   :is-modification="false"
                   :just-save="true"
                   @save="save"
      />
    </template>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import FormLikert from '@/components/questions/formLikert'
import panelMixin from '@/components/questionnaires/fields/editPanels/panelMixin'
import questionPanelMixin from '@/components/questionnaires/fields/editPanels/questionPanelMixin'
import QuestionEditPanelTable
  from '@/components/questionnaires/fields/editPanels/QuestionEditPanelTable/QuestionEditPanelTable'

export default {
  name: 'LikertQuestionEditPanel',
  mixins: [panelMixin, questionPanelMixin],
  components: {
    FormLikert,
    QuestionEditPanelTable
  },
  data () {
    return {
      loadingQuestionLikert: true,
      search: ''
    }
  },
  computed: {
    ...mapGetters('Questions', [
      'questionLikert',
      'questionsLikert'
    ]),
    ...mapGetters('Questionnaires', [
      'usedQuestionIds'
    ]),
    availableLikerts () {
      return this.questionsLikert.filter(
        question => question.id === this.control.value || !this.usedQuestionIds.includes(question.id)
      )
    }
  },
  async created () {
    this.loadingQuestionLikert = false
  },
  methods: {
    ...mapActions('Questions', [
      'createQuestion'
    ]),
    async save (payload) {
      await this.createQuestion(
        {
          question: payload.question,
          saveType: 'saveQuestionnaire'
        }
      )
      this.control.value = this.questionLikert.id
      this.isCreation = false
    }
  }
}
</script>
